
<template>
  <div class="p-max-wrap">
    <div class="p-max-1500">
      <swiper ref="mySwiper"
        :options="swiperOption"
        @slideChangeTransitionStart="slideChange">
        <swiper-slide v-for="item in items"
          :key="item.id">
          <div class="img-wrap">
            <div class="bgimg" :style="item.BIGPIC | bgimgFilter"></div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- Optional controls -->
      <div class="content-wrap">
        <div class="cl auto"></div>
        <div class="cl content">
          <div class="info-box"
            ref="infoBox">
            <div class="anim time ff-tt ft-50">
              {{ item.SHOWTIME | dateFilter }}
            </div>
            <div class="anim detail ft-16">{{ item.TITLE }}</div>
            <div class="anim note ft-12">{{ item.JJ }}</div>
            <!-- <div class="anim note ft-12">{{ item.note1 }}</div> -->

            <div class="anim know-btn-wrap">
              <Knowbtn1 :dark="true"
                @btnclick="gotoPage(item.NEWTYPE, item.ID)" />
            </div>
          </div>
          <div class="btns-wrap">
            <div class="btns">
              <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
              <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
            </div>
          </div>
        </div>
        <div class="cl mask"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Knowbtn1 from '@/components/Knowbtn1.vue'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { TimelineLite, Power2 } from 'gsap/TweenMax'
import { qsa } from '@/util/dom.js'

export default {
  components: {
    swiper,
    swiperSlide,
    Knowbtn1
  },

  props: ['items'],

  data () {
    return {
      swiperOption: {
        // Basic 一般选项
        speed: 1600,
        // Loop 环路
        loop: true,
        /* 组件 */
        // Autoplay 自动切换
        autoplay: {
          // 用户操作swiper之后，是否禁止autoplay
          disableOnInteraction: false
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      activeIndex: 0
    }
  },

  computed: {
    item () {
      return this.items[this.activeIndex] || {
        ID: -1,
        NEWTYPE: -1,
        BIGPIC: '',
        SHOWTIME: '',
        TITLE: '',
        JJ: ''
      }
    }
  },
  methods: {
    slideChange () {
      // this.activeIndex = this.$refs.mySwiper.swiper.realIndex
      this.runAnimate()
    },

    runAnimate () {
      const el = this.$refs.infoBox
      const els = qsa('.anim', el)

      const tl = new TimelineLite()

      tl.to(
        el,
        0.5,
        {
          opacity: 0,
          transform: 'translateX(100px)',
          ease: Power2.easeOut
        }
      ).call(() => {
        if (!this.$refs.mySwiper) return
        this.activeIndex = this.$refs.mySwiper.swiper.realIndex
      }).to(
        el,
        0.5,
        {
          opacity: 1,
          transform: 'translateX(0)',
          ease: Power2.easeIn
        }
      ).staggerFromTo(
        els,
        0.5,
        {
          transform: 'translateX(100px)'
        },
        {
          transform: 'translateX(0)',
          ease: Power2.easeIn
        },
        0.1,
        '-=0.5'
      )
    },

    update () {
      // console.log(this.items)
      this.$refs.mySwiper.swiper.updateSlides()
      this.$refs.mySwiper.swiper.loopDestroy()
      this.$refs.mySwiper.swiper.loopCreate()
    },

    gotoPage (type, id) {
      if (Number(id) < 0) return

      let routeUrl = this.$router.resolve(`/media/${type}/${id}`)
      window.open(routeUrl.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.p-max-1500 {
  position: relative;
}

.img-wrap {
  width: 100%;
  height: 0;
  padding-bottom: 43.66%;
  position: relative;
}

.bgimg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  z-index: 1410;
}

.content-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1420;

  display: flex;

  .auto, .content {
    flex: 1;
  }

  .content {
    position: relative;
    background-color: #fff;

    padding-left: 120px;
    display: flex;
    align-items: center;

    .time {
      line-height: 120px;
    }

    .detail {
      color: #03192f;
      line-height: 40px;
      max-width: 300px;
    }

    .note {
      color: #3c546e;
      line-height: 32px;
      margin-right: 64px;
    }

    .know-btn-wrap {
      margin-top: 60px;
    }
  }

  .mask {
    width: 130px;
    background-color: #207ab5;
    filter: alpha(Opacity=75);
    opacity: 0.75;
  }
}

.btns-wrap {
  position: absolute;
  right: 40px;
  bottom: 100px;
}
.btns {
  width: 120px;
  position: relative;
}
@media(max-width: 768px){
  .content-wrap{
    position: static;
    .auto,
    .mask{
      display: none;
    }
    .content{
      padding: 20px;
      .time{
        font-size: 30px;
        line-height: normal;
      }
      .detail{
        max-width: 100%;
      }
      .note{
        margin-right: 0;
      }
      .btns-wrap{
        bottom: 20px;
        .swiper-button-prev, .swiper-button-next{
          top: auto;
          bottom: 0;
          margin-top: 0;
        }
      }
    }
  }
}
</style>
